(() => {
  const initialize = () => {
    document.querySelectorAll('[data-am-header]').forEach(header => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const disclosures = [...header.querySelectorAll('[data-am-disclosure]')];
      const close = (item, focus = false) => {
        item.open = false;
        item.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) item.querySelector('summary').focus();
      };
      disclosures.forEach(item => {
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(item.open));
          if (item.open) disclosures.filter(other => other !== item).forEach(other => close(other));
        });
        item.querySelector('[data-am-close]').addEventListener('click', () => close(item, true));
        item.addEventListener('keydown', event => {
          if (event.key === 'Escape' && item.open) {
            event.preventDefault();
            event.stopPropagation();
            close(item, true);
          }
        });
      });
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) disclosures.forEach(item => close(item));
        else if (event.relatedTarget) disclosures.forEach(item => {
          if (item.open && !item.contains(event.relatedTarget)) close(item);
        });
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) disclosures.forEach(item => close(item));
      });
      const mobile = header.querySelector('.am-mobile-nav');
      const mobileQuery = window.matchMedia('(max-width:749px)');
      const panel = header.querySelector('.am-nav');
      const opener = header.querySelector('[data-am-mobile-open]');
      const closer = header.querySelector('[data-am-mobile-close]');
      const backdrop = header.querySelector('[data-am-mobile-backdrop]');
      const top = header.querySelector('.am-header__top');
      let drawerOpen = false;
      let previousOverflow = '';
      let inerted = [];
      header.classList.add('am-mobile-enhanced');
      const focusable = () => [...panel.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex="0"]')].filter(element => !element.disabled && element.getClientRects().length);
      const shutDrawer = (restoreFocus = true) => {
        if (drawerOpen) {
          document.body.style.overflow = previousOverflow;
          inerted.forEach(element => { element.inert = false; });
          inerted = [];
        }
        drawerOpen = false;
        header.classList.remove('am-mobile-open');
        opener.setAttribute('aria-expanded', 'false');
        backdrop.hidden = true;
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.inert = mobileQuery.matches;
        if (mobileQuery.matches) panel.setAttribute('aria-hidden', 'true');
        else panel.removeAttribute('aria-hidden');
        mobile.open = true;
        if (restoreFocus && mobileQuery.matches) opener.focus();
      };
      opener.addEventListener('click', () => {
        if (!mobileQuery.matches || drawerOpen) return;
        drawerOpen = true;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const outside = [...document.body.children].filter(element => !element.contains(header) && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName));
        const content = [...document.querySelectorAll('main, #MainContent, footer, .shopify-section-group-footer-group')].filter(element => !element.contains(header));
        inerted = [...new Set([...outside, ...content, top])].filter(element => !element.inert);
        inerted.forEach(element => { element.inert = true; });
        panel.inert = false;
        panel.removeAttribute('aria-hidden');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        header.classList.add('am-mobile-open');
        opener.setAttribute('aria-expanded', 'true');
        backdrop.hidden = false;
        mobile.open = true;
        closer.focus();
      });
      closer.addEventListener('click', () => shutDrawer());
      backdrop.addEventListener('click', () => shutDrawer());
      panel.addEventListener('keydown', event => {
        if (!drawerOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          shutDrawer();
        }
        if (event.key === 'Tab') {
          const elements = focusable();
          const first = elements[0];
          const last = elements[elements.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      panel.addEventListener('click', event => {
        if (drawerOpen && event.target.closest('a[href]')) shutDrawer(false);
      });
      mobileQuery.addEventListener('change', () => {
        shutDrawer(false);
        disclosures.forEach(item => close(item));
      });
      shutDrawer(false);
      window.addEventListener('pageshow', event => {
        if (event.persisted) {
          shutDrawer(false);
          disclosures.forEach(item => close(item));
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

